module.exports = __webpack_public_path__ + "static/media/401.fac81265.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UnAuthorized/401.svg
// module id = 3034
// module chunks = 0